import type { IPagination } from "../../../../types/models/pagination.models.types";
import type { IPayoutTransactionMinimal } from "../../../../types/models/payout-transaction.modals.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
	transactions: Array<IPayoutTransactionMinimal>;
	pagination: IPagination;
}

export function useGetPayoutTransactionsAdminHttp() {
	return useGetHttp<IResponse>({
		path: "/admin/payouts/transactions",
	});
}
